$(function() {
    // console.log('homepage');
});